// ポップアップ
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ButtonStatus {
  label: string;
  variant: string;
  class_name?: string;
  handleClick: () => void;
}

interface Props {
  title?: string;
  sub_title?: string;
  last_update?: string;
  text: string;
  toggleShow: boolean;
  toggleClose: React.MouseEventHandler;
  first_button: ButtonStatus;
  second_button?: ButtonStatus;
}

const Popup: React.FC<Props> = ({
  title,
  sub_title,
  last_update,
  text,
  toggleShow,
  toggleClose,
  first_button,
  second_button,
}) => {
  return (
    <Modal
      size="lg"
      show={toggleShow}
      onHide={toggleClose}
      animation={false}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        {title && (
          <Modal.Title>
            <div className="modal-heading-title">{title}</div>
          </Modal.Title>
        )}
      </Modal.Header>
      <Modal.Body className="pt-0">
        {last_update && <div className="p-lead mt-0 mb-3">最終更新日:{last_update}</div>}
        {sub_title && <div className="heading-s">{sub_title}</div>}
        <div className="p-lead popup_text" dangerouslySetInnerHTML={{ __html: text }}></div>
      </Modal.Body>
      <Modal.Footer>
        <div
          className={`btn-area ${second_button ? 'two-btn' : 'one-btn'} ${first_button.class_name}`}
        >
          <Button variant={first_button.variant} onClick={first_button.handleClick}>
            {first_button.label}
          </Button>
          {second_button && (
            <Button variant={second_button.variant} onClick={second_button.handleClick}>
              {second_button.label}
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default Popup;
